import { useNavigate } from "react-router-dom"

import { useState } from "react"
import FullScreenLayout from "../../../../components/FullScreenLayout"
import { useGetNotifications } from "../hooks/useGetNotifications"
import { parseNotificationMessage } from "../utils/parseNotificationMessage"
import DateFilter from "./DateFilter"

const Notifications = () => {
    const navigate = useNavigate()
    const { notifications, isLoading } = useGetNotifications()

    const [selectedDate, setSelectedDate] = useState<string>(() => {
        const today = new Date()
        return today.toISOString().slice(0, 10) // Format: 'YYYY-MM-DD'
      })

    const filteredNotifications = selectedDate
        ? notifications.filter((n) => {
            const notifDate = new Date(n.created_at).toISOString().slice(0, 10)
            return notifDate === selectedDate
        })
        : notifications

    const handleBack = () => {
        navigate("/platform-experts/analytics")
    }

    if (isLoading) {
        return (
            <FullScreenLayout title="Notifiche" showBackButton={true} onBack={handleBack} backButtonText="Torna a Analytics">
                <div className="w-full h-full flex flex-col items-center justify-center">
                    <div className="text-gray-600">Caricamento notifiche...</div>
                </div>
            </FullScreenLayout>
        )
    }

    return (
        <FullScreenLayout title="Notifiche" showBackButton={true} onBack={handleBack} backButtonText="Torna a Analytics">
            <div className="w-full flex flex-col space-y-6">
                <DateFilter value={selectedDate} onChange={setSelectedDate} />
                <div className="overflow-y-auto max-h-[600px] space-y-4 pr-4">
                    {filteredNotifications.map((notification, index) => {
                        const parsed = parseNotificationMessage(notification.message)

                        return (
                            <div key={index} className="border border-gray-200 rounded-2xl shadow-sm p-4 bg-white">
                                <div><span className="font-semibold">Event Type:</span> {notification.event_type}</div>
                                {parsed && (
                                    <>
                                        <div><span className="font-semibold">Email:</span> {parsed.email}</div>
                                        <div><span className="font-semibold">Code Type:</span> {parsed.codeType}</div>
                                        <div><span className="font-semibold">Code:</span> {parsed.code}</div>
                                    </>
                                )}
                            </div>
                        )
                    })}
                    {filteredNotifications.length === 0 && (
                        <div className="text-center text-gray-500 py-8">
                            Nessuna notifica trovata per la data selezionata.
                        </div>
                    )}
                </div>
            </div>
        </FullScreenLayout>
    )
}

export default Notifications
